import React, { Fragment } from 'react'
import Seo from '@components/Seo'
import Product from '@containers/Product'
import Ctas from '@components/Ctas'
import ContactDetails from '@components/ContactDetails'
import * as R from 'ramda'

const ProductPage = ({ data }) => {
  const metaTitle = R.pathOr('', ['contentfulPage', 'metaTitle'], data)
  const metaDescription = R.pathOr('', ['contentfulPage', 'metaDescription'], data)
  const canonicalUrl = R.pathOr('', ['contentfulPage', 'canonicalUrl'], data)
  const slug = R.pathOr('', ['contentfulPage', 'slug'], data)
  const product = R.pathOr('', ['contentfulPage', 'template', '0'], data)
  const ctaComponents = R.pathOr([], ['ctaBlock', 'ctaComponents'], product)
  const contactDetailsData = R.pathOr([], ['allContentfulContactComponent', 'edges', '0', 'node'], data)

  product.slug = slug

  return (
    <Fragment>
      <Seo
        title={metaTitle}
        canonicalUrl={canonicalUrl}
        description={metaDescription}
      />
      {product && <Product product={product} />}
      {R.not(R.isEmpty(ctaComponents)) && <Ctas data={ctaComponents} />}
      {contactDetailsData && <ContactDetails data={contactDetailsData} />}
    </Fragment>
  )
}

export const query = graphql`
query productQuery($slug: String) {
  contentfulPage(slug: {eq: $slug}) {
    title
    metaTitle
    canonicalUrl
    metaDescription
    slug
    template {
      ... on ContentfulProductTemplate {
        __typename
        title
        shortName
        productCode
        description {
          childMarkdownRemark {
            html
          }
        }
        image {
          resize(width: 600) {
            src
          }
        }
        ppe {
          contentful_id
          title
          description {
            description
          }
        }    
        optionalExtras {
          ... on ContentfulPage {
            title
            slug
            template {
              ... on ContentfulProductTemplate {
                productCode
                image {
                  resize(width: 600) {
                    src
                  }
                }
                ppe {
                  title
                }
              }
            }      
          }
        }
        variants {
          ... on ContentfulPage {
            title
            slug
            template {
              ... on ContentfulProductTemplate {
                shortName
                spec {
                  ... on ContentfulSpecComponent {
                    ...technicalSpecificationFields
                  }
                }
              }
            }
          }
        }
        spec {
          ...technicalSpecificationFields
        }
        ctaBlock {
          ... on ContentfulCtaBlock {
            ctaComponents {
              ... on ContentfulCtaComponent {
                id
                title
                page {
                  contentful_id
                  slug
                }
                image {
                  resize(width: 600) {
                    src
                  }
                }
              }
            }
          }
        }
        category
      }
    }
  }
  allContentfulContactComponent {
    edges {
      node {
        instruction
        phone
        callback
        hours
        excluding
        email
      }
    }
  }
  allContentfulCtaComponent {
    edges {
      node {
        id
        title
        page {
          contentful_id
          slug
        }
        image {
          resize(width: 600) {
            src
          }
        }
      }
    }
  }
}
`

export default ProductPage



// WEBPACK FOOTER //
// ./src/templates/product.js